/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntegrationActivityEvent } from '../models/IntegrationActivityEvent';
import type { IntegrationActivityEventCreateParams } from '../models/IntegrationActivityEventCreateParams';
import type { IntegrationActivityEventListResponse } from '../models/IntegrationActivityEventListResponse';
import type { IntegrationActivityEventScope } from '../models/IntegrationActivityEventScope';
import type { IntegrationActivityEventStatus } from '../models/IntegrationActivityEventStatus';
import type { IntegrationActivityEventType } from '../models/IntegrationActivityEventType';
import type { IntegrationConnectBody } from '../models/IntegrationConnectBody';
import type { IntegrationConnectedAccountResponse } from '../models/IntegrationConnectedAccountResponse';
import type { IntegrationConnectionResolveBody } from '../models/IntegrationConnectionResolveBody';
import type { IntegrationConnectionResolveResponse } from '../models/IntegrationConnectionResolveResponse';
import type { IntegrationDisconnectResponse } from '../models/IntegrationDisconnectResponse';
import type { IntegrationProviderId } from '../models/IntegrationProviderId';
import type { IntegrationsListResponse } from '../models/IntegrationsListResponse';
import type { IntegrationsSyncDueResponse } from '../models/IntegrationsSyncDueResponse';
import type { IntegrationsSyncEnqueuedBody } from '../models/IntegrationsSyncEnqueuedBody';
import type { IntegrationsSyncEnqueuedResponse } from '../models/IntegrationsSyncEnqueuedResponse';
import type { IntegrationsSyncResultBody } from '../models/IntegrationsSyncResultBody';
import type { IntegrationsSyncResultResponse } from '../models/IntegrationsSyncResultResponse';
import type { IntegrationSyncBody } from '../models/IntegrationSyncBody';
import type { IntegrationSyncResponse } from '../models/IntegrationSyncResponse';
import type { MeliOAuthCallbackResponse } from '../models/MeliOAuthCallbackResponse';
import type { MeliOAuthStartResponse } from '../models/MeliOAuthStartResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntegrationsService {
    /**
     * Starts the Credentials-managed MeLi OAuth authorization flow.
     * @returns MeliOAuthStartResponse Ok
     * @throws ApiError
     */
    public static startMeliOAuth(): CancelablePromise<MeliOAuthStartResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/oauth/meli/start',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Browser callback endpoint for MeLi OAuth.
     * @param code
     * @param state
     * @param error
     * @param errorDescription
     * @returns any Ok
     * @throws ApiError
     */
    public static meliOAuthCallback(
        code?: string,
        state?: string,
        error?: string,
        errorDescription?: string,
    ): CancelablePromise<MeliOAuthCallbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/integrations/oauth/meli/callback',
            query: {
                'code': code,
                'state': state,
                'error': error,
                'error_description': errorDescription,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List supported integrations and the current tenant connection status.
     * @returns IntegrationsListResponse Ok
     * @throws ApiError
     */
    public static listIntegrations(): CancelablePromise<IntegrationsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/integrations',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Connect or update an integration for the current tenant.
     * @param providerId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static connectIntegration(
        providerId: IntegrationProviderId,
        requestBody: IntegrationConnectBody,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/integrations/{providerId}',
            path: {
                'providerId': providerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Disconnect an integration for the current tenant.
     * @param providerId
     * @returns IntegrationDisconnectResponse Ok
     * @throws ApiError
     */
    public static disconnectIntegration(
        providerId: IntegrationProviderId,
    ): CancelablePromise<IntegrationDisconnectResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/integrations/{providerId}',
            path: {
                'providerId': providerId,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Resolves a canonical integration connection id from provider-routing metadata.
     * @param requestBody
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @param tenantId
     * @returns IntegrationConnectionResolveResponse Ok
     * @throws ApiError
     */
    public static resolveConnection(
        requestBody: IntegrationConnectionResolveBody,
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
        tenantId?: string,
    ): CancelablePromise<IntegrationConnectionResolveResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/connections/resolve',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Enqueue a sync for the integration (manual/forced).
     * @param providerId
     * @param requestBody
     * @returns IntegrationSyncResponse Ok
     * @throws ApiError
     */
    public static enqueueIntegrationSync(
        providerId: IntegrationProviderId,
        requestBody?: IntegrationSyncBody,
    ): CancelablePromise<IntegrationSyncResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/{providerId}/sync',
            path: {
                'providerId': providerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List due connections for scheduler workflows.
     * @param limit
     * @param pageToken
     * @param providerId
     * @returns IntegrationsSyncDueResponse Ok
     * @throws ApiError
     */
    public static listDueSyncConnections(
        limit?: number,
        pageToken?: string,
        providerId?: IntegrationProviderId,
    ): CancelablePromise<IntegrationsSyncDueResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/sync/due',
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'providerId': providerId,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Mark integrations as "sync enqueued" (scheduler acknowledgement).
     * @param requestBody
     * @returns IntegrationsSyncEnqueuedResponse Ok
     * @throws ApiError
     */
    public static acknowledgeSyncEnqueued(
        requestBody: IntegrationsSyncEnqueuedBody,
    ): CancelablePromise<IntegrationsSyncEnqueuedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/sync/enqueued',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Record the result of a sync run (jobs -> backend).
     * @param requestBody
     * @returns IntegrationsSyncResultResponse Ok
     * @throws ApiError
     */
    public static recordSyncResult(
        requestBody: IntegrationsSyncResultBody,
    ): CancelablePromise<IntegrationsSyncResultResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/sync/result',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Returns the live external account behind a configured integration.
     * @param providerId - Integration provider whose authorized account is requested.
     * @returns IntegrationConnectedAccountResponse Provider-neutral connected-account identity and configuration match state.
     * @throws ApiError
     */
    public static getConnectedAccount(
        providerId: IntegrationProviderId,
    ): CancelablePromise<IntegrationConnectedAccountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/integrations/{providerId}/account',
            path: {
                'providerId': providerId,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Lists unified integration activity events for the current tenant.
     * @param integrationConnectionId
     * @param provider
     * @param propertyId
     * @param propertyPortalPublicationId
     * @param externalSourceId
     * @param scope
     * @param status
     * @param type
     * @param dateFrom
     * @param dateTo
     * @param pageSize
     * @param pageToken
     * @returns IntegrationActivityEventListResponse Ok
     * @throws ApiError
     */
    public static listActivityEvents(
        integrationConnectionId?: number,
        provider?: string,
        propertyId?: number,
        propertyPortalPublicationId?: number,
        externalSourceId?: string,
        scope?: Array<IntegrationActivityEventScope>,
        status?: Array<IntegrationActivityEventStatus>,
        type?: Array<IntegrationActivityEventType>,
        dateFrom?: string,
        dateTo?: string,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<IntegrationActivityEventListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/integrations/activity-events',
            query: {
                'integrationConnectionId': integrationConnectionId,
                'provider': provider,
                'propertyId': propertyId,
                'propertyPortalPublicationId': propertyPortalPublicationId,
                'externalSourceId': externalSourceId,
                'scope': scope,
                'status': status,
                'type': type,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Records a unified integration activity event for the current tenant.
     * @param requestBody
     * @returns IntegrationActivityEvent Ok
     * @throws ApiError
     */
    public static recordActivityEvent(
        requestBody: IntegrationActivityEventCreateParams,
    ): CancelablePromise<IntegrationActivityEvent> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/activity-events',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
